import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaaRequestFlowComponent } from '../baa-request-flow/baa-request-flow.component';
import { FfdNotesInviteWelcomeComponent } from '../ffd-notes-invite-welcome/ffd-notes-invite-welcome.component';

@Component({
  selector: 'lib-ffd-notes-invitation-landing',
  imports: [BaaRequestFlowComponent, FfdNotesInviteWelcomeComponent],
  templateUrl: './ffd-notes-invitation-landing.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FfdNotesInvitationLandingComponent {
  private readonly activatedRoute = inject(ActivatedRoute);

  protected readonly hasJoinRequestId = this.activatedRoute.snapshot.queryParamMap.has('joinRequestId');
}
